export const mmgrVersions = {
  G5: 'G5',
  G6: 'G6'
};